import axios from 'axios';
import moment from 'moment';
import { underscoreKeys } from '@/lib/functions';

export default class Api {
  constructor(store) {
    this.store = store;
    this.client = axios.create({
      baseURL: process.env.VUE_APP_API_V2,
    });
  }

  headers() {
    if (this.store.getters.tokens) {
      return {
        Authorization: `bearer: ${this.store.getters.tokens.accessToken}`,
      };
    }
    return {};
  }

  registerUserWithEvent(user, eventId, pwrlabEmailAddress) {
    console.log(this.headers());
    const data = {
      emailAddress: user.emailAddress,
      email: user.emailAddress,
      firstName: user.firstName,
      lastName: user.lastName,
      gender: user.gender,
      age: moment().diff(moment(user.birthDate), 'years'),
      birthdate: user.birthDate,
      pwrLabEmail: user.havePwrLabEmail && pwrlabEmailAddress,
      registrationTimestamp: new Date(2021, 11, 31).toString(),
    };
    if ('teamName' in user) data.teamName = user.teamName;
    return this.client.post(`/distributed-events/${eventId}/register`, underscoreKeys(data), { headers: this.headers() });
  }

  saveSurvey(data, surveyId, sub) {
    return this.client.post('/survey/documents', {
      schema: surveyId,
      sub,
      data,
    }, { headers: this.headers() });
  }

  listCohortMembers(user) {
    return this.client.get(`/iaaa/cohort-members?user=${user}`, { headers: this.headers() });
  }

  // eslint-disable-next-line class-methods-use-this
  checkIfCohortMember(email, cohort) {
    return this.client.get(`/iaaa/is-cohort-member?email=${email}&cohort=${cohort}`);
  }

  // eslint-disable-next-line class-methods-use-this
  getCohort(cohortId) {
    return this.client.get(`iaaa/cohort/${cohortId}`);
  }


  updateCohortMemberPermissions(id, permission) {
    return this.client.put(`/iaaa/cohort-members/${id}/permissions`, { permission }, { headers: this.headers() });
  }

  optOut(user) {
    return this.client.put('/iaaa/cohort-members/opt-out', { user }, { headers: this.headers() });
  }

  listMemberEvents(user) {
    return this.client.get(`/distributed-events/member-events/${user}`, { headers: this.headers() });
  }
}
